module.exports = __webpack_public_path__ + "static/img/iPhone.6762adba.png";